import styled from "styled-components";

export const CssHome = styled.div`
	width: 100%;
	background: #ff0b05;
	font-family: "Barlow", sans-serif;

	.caseHero {
		width: 100%;
		min-height: 700px;
		background: #ff0b05;
		position: relative;
		margin-top: 75px;
		overflow: hidden;
	}

	.caseContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 700px;
		margin: 0 auto;
		position: relative;
		padding: 43px 4% 70px;
		box-sizing: border-box;
	}

	

	.heroContent {
		width: 100%;
		display: grid;
		grid-template-columns: 1.05fr 0.95fr;
		gap: 55px;
		align-items: center;
		margin-top: 85px;
	}

	.heroLeft {
		width: 100%;
	}

	.heroTitle {
		margin: 0;
		max-width: 560px;
		color: #d9f7ff;
		font-size: 50px;
		line-height: 1.04;
		font-weight: 400;
		letter-spacing: -0.055em;
		overflow: hidden;
	}

	.titleLine {
		display: block;
		opacity: 0;
		will-change: transform, opacity;
	}

	.titleTop {
		animation: titleFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.2s both;
	}

	.titleBottom {
		animation: titleFromBottom 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.45s both;
	}

	.titleBottom strong {
		font-weight: 800;
		color: #80EDFF;
	}

	.heroClients {
		margin-top: 42px;
		opacity: 0;
		animation: fromLeftFade 0.8s cubic-bezier(0.22, 1, 0.36, 1) 1.15s both;
	}

	.heroClients h2 {
		margin: 0 0 24px;
		color: #80EDFF;
		font-size: 30px;
		line-height: 1.05;
		font-weight: 600;
		letter-spacing: -0.05em;
	}

	.clientsGrid {
		display: grid;
		grid-template-columns: repeat(2, max-content);
		column-gap: 24px;
		row-gap: 16px;
	}

	.clientLink {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		color: #80EDFF;
		font-size: 20px;
		line-height: 1.05;
		font-weight: 400;
		text-decoration: underline;
		text-underline-offset: 3px;
		letter-spacing: -0.045em;
	}

	.clientLink img {
		width: 16px;
		height: auto;
		display: block;
		transition: transform 0.45s ease;
		transform-origin: center;
	}

	.clientLink:hover img {
		transform: rotate(-45deg);
	}

	.heroRight {
		width: 100%;
		display: flex;
		justify-content: flex-end;
	}

	.heroDescription {
		max-width: 600px;
		margin: 0;
		color: #80EDFF;
		font-size:20px;
		line-height: 1.45;
		font-weight: 400;
		text-align: right;
		letter-spacing: -0.045em;
		opacity: 0;
		animation: fromBottomFade 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.6s both;
	}

	@keyframes titleFromTop {
		from {
			opacity: 0;
			transform: translateY(-70px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes titleFromBottom {
		from {
			opacity: 0;
			transform: translateY(70px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes fromLeftFade {
		from {
			opacity: 0;
			transform: translateX(-70px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes fromBottomFade {
		from {
			opacity: 0;
			transform: translateY(55px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@media (max-width: 1366px) {
		.caseContainer {
			padding: 43px 5.5% 70px;
		}

		.heroContent {
			gap: 40px;
		}
	}

	@media (max-width: 1100px) {
		.caseHero {
			min-height: 640px;
		}

		.caseContainer {
			min-height: 640px;
			padding: 38px 32px 60px;
		}

		.heroContent {
			grid-template-columns: 1fr;
			align-items: start;
			margin-top: 70px;
			gap: 55px;
		}

		.heroRight {
			justify-content: flex-start;
		}

		.heroDescription {
			max-width: 760px;
			text-align: left;
		}
	}

	@media (max-width: 768px) {
		.caseHero,
		.caseContainer {
			min-height: auto;
		}

		.caseTop {
			align-items: flex-start;
		}

		.caseNav {
			font-size: 16px;
		}

		.caseNav img {
			width: 13px;
		}

		.heroContent {
			margin-top: 55px;
			gap: 45px;
		}

		.heroTitle {
			max-width: 100%;
			font-size: 44px;
		}

		.heroClients {
			margin-top: 32px;
		}

		.heroClients h2 {
			font-size: 28px;
		}

		.clientsGrid {
			grid-template-columns: 1fr;
			row-gap: 14px;
		}

		.clientLink {
			font-size: 24px;
		}

		.heroDescription {
			font-size: 22px;
			line-height: 1.4;
		}
	}

	@media (max-width: 520px) {
		.caseContainer {
			padding: 32px 24px 50px;
		}

		.caseTop {
			flex-wrap: wrap;
			row-gap: 16px;
		}

		.caseNav {
			font-size: 14px;
		}

		.caseNav img {
			width: 11px;
		}

		.heroContent {
			margin-top: 40px;
			gap: 36px;
		}

		.heroTitle {
			font-size: 33px;
			line-height: 1.08;
		}

		.heroClients h2 {
			font-size: 22px;
			margin-bottom: 18px;
		}

		.clientLink {
			font-size: 18px;
		}

		.clientLink img {
			width: 13px;
		}

		.heroDescription {
			font-size: 18px;
			line-height: 1.45;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.titleLine,
		.heroClients,
		.heroDescription {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}

		.caseNav img,
		.clientLink img {
			transition: none !important;
		}
	}
`;

export const CssKevlar = styled.div`
	width: 100%;
	background: #f5efd9;
	font-family: "Barlow", sans-serif;
	/* overflow: hidden; */

	.kevlarSocialSection {
		width: 100%;
		min-height: 290px;
		background: #f5efd9;
		position: relative;
		overflow: visible;
	}

	.kevlarSocialContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 290px;
		margin: 0 auto;
		position: relative;
		padding: 0 4%;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: 36% 64%;
		align-items: center;
	}

	.kevlarSocialZ {
		position: absolute;
		top: -66px;
		left: 28.7%;
		width: 168px;
		height: auto;
		display: block;
		z-index: 4;
		opacity: 0;
		will-change: transform, opacity;
	}

	.kevlarSocialLogoBox {
		position: relative;
		z-index: 5;
		margin-top: 34px;
		opacity: 0;
		will-change: transform, opacity;
	}

	.kevlarSocialLogo {
		width: 230px;
		max-width: 100%;
		height: auto;
		display: block;
	}

	.kevlarSocialUser {
		margin: 5px 0 0;
		color: #ff0b05;
		font-size: 18px;
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.035em;
		opacity: 0;
		will-change: transform, opacity;
	}

	.kevlarSocialText {
		width: 100%;
		max-width: 610px;
		margin: 44px 0 0 auto;
		color: #172124;
		font-size: 17px;
		line-height: 1.35;
		font-weight: 600;
		text-align: center;
		letter-spacing: -0.04em;
		opacity: 0;
		will-change: transform, opacity;

		span {
			display: block;
		}
	}

	&.isVisible .kevlarSocialZ {
		animation: kevlarZFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	&.isVisible .kevlarSocialLogoBox {
		animation: kevlarLogoFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.45s both;
	}

	&.isVisible .kevlarSocialUser {
		animation: kevlarLogoFromLeft 0.75s cubic-bezier(0.22, 1, 0.36, 1) 0.8s both;
	}

	&.isVisible .kevlarSocialText {
		animation: kevlarTextFromBottom 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.1s both;
	}

	/* =========================================================
	   CONTINUAÇÃO KEVLAR
	   Parte 1: bgKevlar como background, 100k, foto, zBranco e 53k
	   Parte 2: quadroKevlar 100% largura da tela + faixaAzul
	========================================================= */

	.kevlarExtraSection {
		width: 100%;		
		position: relative;
		overflow: hidden;
		padding: 0;
	}

	/* PARTE 1 */
	.kevlarExtraPartOne {
		width: 100%;
		height: 950px;
		position: relative;
		overflow: hidden;	
		background-repeat: no-repeat;
		background-position: top center;
		background-size: cover;
	}

	.kevlarExtraContainer {
		width: 100%;
		max-width: 1440px;
		height: 950px;
		margin: 0 auto;
		position: relative;
		z-index: 3;
		padding: 0 4%;
		box-sizing: border-box;
	}

	.kevlarMetric {
		position: absolute;
		z-index: 8;
		opacity: 0;
		will-change: transform, opacity;
	}

	.kevlarMetric strong {
		display: block;
		color: #80edff;
		font-size: clamp(64px, 7.5vw, 116px);
		line-height: 0.82;
		font-weight: 800;
		letter-spacing: -0.075em;
	}

	.kevlarMetric span {
		display: block;
		margin-top: 10px;
		color: #80edff;
		font-size: clamp(14px, 1.15vw, 21px);
		line-height: 1.05;
		font-weight: 500;
		letter-spacing: -0.045em;
	}

	.kevlarMetric100 {
		left: 25%;
		top: 55px;
	}

	.kevlarMetric53 {
		right: 23%;
    	top: 460px;
	}

	.kevlarPhotoMainWrap {
		position: absolute;
		top: 60px;
		left: 50%;
		width: 370px;
		height: auto;
		border-radius: 6px;
		overflow: hidden;
		z-index: 6;
		opacity: 0;
		transform: translateX(-50%);
		will-change: transform, opacity;
	}

	.kevlarPhotoMain {
		width: 100%;
		height: auto;
		display: block;
	}

	.kevlarWhiteZ {
		position: absolute;
		left: 32%;
		top: 66%;
		width: 145px;
		height: auto;
		display: block;
		z-index: 9;
		opacity: 0;
		will-change: transform, opacity;
	}

	/* PARTE 2 */
	.kevlarExtraPartTwo {
		width: 100vw;
		min-height: 610px;	
		position: relative;
		overflow: hidden;
		margin-top: -200px;
		margin-left: calc(50% - 50vw);
		z-index: 5;
	}

	.kevlarFrameContainer {
		width: 100vw;
		min-height: 610px;
		margin: 0;
		position: relative;
		padding: 0;
		box-sizing: border-box;
		overflow: hidden;
	}

	.kevlarGridWrap {
		position: relative;
		left: 0;
		top: 0;
		width: 100vw;
		height: auto;
		z-index: 6;
		overflow: hidden;
		opacity: 0;
		will-change: transform, opacity;
	}

	.kevlarGridImage {
		width: 100vw;
		height: auto;
		display: block;
		transform: translateX(0) scale(1);
		transform-origin: center center;
		transition: transform 0.7s ease;
		will-change: transform;
	}

	.kevlarGridWrap:hover .kevlarGridImage {
		transform: translateX(-34px) scale(1.08);
	}

	.kevlarBlueStripe {
		position: absolute;
		right: 0;
		top: 48%;
		width:200px;
		height: auto;
		display: block;
		z-index: 9;
		opacity: 0;
		will-change: transform, opacity;
	}

	/* ORDEM DA ANIMAÇÃO - PARTE 1 */
	&.isExtraVisible .kevlarMetric100 {
		animation: kevlarFromLeft 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	&.isExtraVisible .kevlarPhotoMainWrap {
		animation: kevlarPhotoFromRight 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.45s both;
	}

	&.isExtraVisible .kevlarMetric53 {
		animation: kevlarFromBottom 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.85s both;
	}

	&.isExtraVisible .kevlarWhiteZ {
		animation: kevlarSoftAppear 0.75s cubic-bezier(0.22, 1, 0.36, 1) 1.15s both;
	}

	/* ORDEM DA ANIMAÇÃO - PARTE 2 */
	&.isExtraVisible .kevlarGridWrap {
		animation: kevlarFromBottom 0.9s cubic-bezier(0.22, 1, 0.36, 1) 1.45s both;
	}

	&.isExtraVisible .kevlarBlueStripe {
		animation: kevlarFromRight 0.8s cubic-bezier(0.22, 1, 0.36, 1) 1.85s both;
	}

	@keyframes kevlarZFromTop {
		from {
			opacity: 0;
			transform: translateY(-95px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes kevlarLogoFromLeft {
		from {
			opacity: 0;
			transform: translateX(-85px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes kevlarTextFromBottom {
		from {
			opacity: 0;
			transform: translateY(60px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes kevlarFromLeft {
		from {
			opacity: 0;
			transform: translateX(-90px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes kevlarFromRight {
		from {
			opacity: 0;
			transform: translateX(90px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes kevlarPhotoFromRight {
		from {
			opacity: 0;
			transform: translateX(calc(-50% + 120px));
		}

		to {
			opacity: 1;
			transform: translateX(-50%);
		}
	}

	@keyframes kevlarFromBottom {
		from {
			opacity: 0;
			transform: translateY(80px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes kevlarSoftAppear {
		from {
			opacity: 0;
			transform: translateY(24px) scale(0.96);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@media (max-width: 1366px) {
		.kevlarSocialContainer {
			padding: 0 5.5%;
		}

		.kevlarSocialZ {
			left: 28.8%;
		}

		.kevlarExtraContainer {
			padding: 0 5.5%;
		}
		
		.kevlarMetric100 {
			left: 25%;
			top: 90px;
		}

		.kevlarMetric53 {
			right: 25%;
			top: 460px;
		}

	}

	@media (max-width: 1100px) {
		.kevlarSocialContainer {
			padding: 0 32px;
			grid-template-columns: 38% 62%;
		}

		.kevlarSocialZ {
			left: 30%;
			width: 150px;
		}

		.kevlarSocialLogo {
			width: 210px;
		}

		.kevlarSocialText {
			max-width: 560px;
			font-size: 16px;
		}

		.kevlarExtraPartOne {
			height: 830px;
		}

		.kevlarExtraContainer {
			height: 830px;
			padding: 0 32px;
		}

		.kevlarMetric100 {
			left: 22%;
        	top: 95px;
		}
		

		.kevlarPhotoMainWrap {
			width: 330px;
		}

		.kevlarWhiteZ {
			left: 25%;		
			width: 120px;
		}

		.kevlarExtraPartTwo {
			min-height: 540px;			
		}

		.kevlarFrameContainer {
			min-height: 540px;
		}

		.kevlarBlueStripe {			
			width: 170px;
		}
	}

	@media (max-width: 768px) {
		.kevlarSocialSection {
			min-height: auto;
			padding: 40px 0 60px;
		}

		.kevlarSocialContainer {
			min-height: auto;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			padding: 0 32px;
		}

		.kevlarSocialZ {
			position: relative;
			top: auto;
			left: auto;
			width: 140px;
			margin: -90px auto 42px;
		}

		.kevlarSocialLogoBox {
			margin-top: 0;
		}

		.kevlarSocialLogo {
			width: 200px;
		}

		.kevlarSocialText {
			max-width: 100%;
			margin: 45px 0 0;
			text-align: left;
			font-size: 17px;

			span {
				display: inline;
			}
		}

		.kevlarExtraPartOne {
			height: 660px;
			background-size: cover;
		}

		.kevlarExtraContainer {
			height: 450px;
			padding: 0 24px;
		}

		.kevlarMetric100 {
			left: 24px;
			top: 34px;
		}

		.kevlarMetric53 {
			right: 24px;
			top: 245px;
		}

		.kevlarMetric strong {
			font-size: 58px;
		}

		.kevlarMetric span {
			font-size: 13px;
		}

		.kevlarPhotoMainWrap {
			width: 285px;
		}

		.kevlarWhiteZ {
			left: 22%;			
			width: 95px;
			top: 94%;
		}

		.kevlarExtraPartTwo {
			min-height: 450px;
			margin-top: -90px;
		}

		.kevlarFrameContainer {
			min-height: 450px;
		}

		.kevlarGridWrap:hover .kevlarGridImage {
			transform: translateX(-18px) scale(1.06);
		}

		.kevlarBlueStripe {			
			width: 145px;
		}
	}

	@media (max-width: 520px) {
		.kevlarSocialSection {
			padding: 34px 0 50px;
		}

		.kevlarSocialContainer {
			padding: 0 24px;
		}

		.kevlarSocialZ {
			width: 90px;
			margin-top: -75px;
			margin-bottom: 36px;
		}

		.kevlarSocialLogo {
			width: 180px;
		}

		.kevlarSocialUser {
			font-size: 18px;
		}

		.kevlarSocialText {
			font-size: 18px;
			line-height: 1.4;
		}

		.kevlarExtraPartOne {
			height: 600px;
			background-size: cover;
		}

		.kevlarExtraContainer {
			height: 600px;
			padding: 0 18px;
		}

		.kevlarMetric100 {
			left: 18px;
			top:80px;
		}

		.kevlarMetric53 {
			right:10px;
			top: 350px;
		}

		.kevlarMetric strong {
			font-size: 46px;
		}

		.kevlarMetric span {
			font-size: 11px;
		}

		.kevlarPhotoMainWrap {
			width: 235px;
		}

		.kevlarWhiteZ {
			left: 18%;			
			width: 76px;
			top: 63%;
		}

		.kevlarExtraPartTwo {
			min-height: 250px;
			margin-top: -100px;
		}

		.kevlarFrameContainer {
			min-height: 250px;
		}

		.kevlarBlueStripe {
			width: 67px;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.kevlarSocialZ,
		.kevlarSocialLogoBox,
		.kevlarSocialUser,
		.kevlarSocialText,
		.kevlarMetric,
		.kevlarPhotoMainWrap,
		.kevlarWhiteZ,
		.kevlarGridWrap,
		.kevlarBlueStripe {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}

		.kevlarGridImage {
			transition: none !important;
			transform: none !important;
		}
	}
`;

export const CssSuvinil = styled.div`
	width: 100%;
	background: #e80000;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	img {
		max-width: 100%;
		display: block;
	}

	/* =========================================================
	PARTE 1 - INTRO SUVINIL
	========================================================= */

	.suvinilIntroSection {
		width: 100%;
		background: #e80000;
		position: relative;
		overflow: hidden;
		padding: 0;
	}

	.suvinilIntroContainer {
		width: 100%;
		background: #e80000;
		position: relative;
		overflow: hidden;
	}

	/* FAIXA VERMELHA SUPERIOR */
	.suvinilIntroTop {
		width: 100%;
		max-width: 1440px;
		min-height: 215px;
		margin: 0 auto;
		padding: 62px 6% 48px;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: 34% 66%;
		align-items: center;
		position: relative;
		z-index: 5;
	}

	.suvinilIntroBrand {
		position: relative;
		z-index: 3;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilLogo {
		width: 285px;
		height: auto;
		display: block;
	}

	.suvinilUser {
		margin: 15px 0 0;
		color: #ffffff;
		font-size: 18px;
		line-height: 1;
		font-weight: 500;
		letter-spacing: -0.035em;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilIntroText {
		max-width: 560px;
		margin: 0 auto;
		color: #ffffff;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 400;
		letter-spacing: -0.035em;
		text-align: center;
		opacity: 0;
		will-change: transform, opacity;
	}

	/* GIF FULL WIDTH */
	.suvinilGifWrap {
		width: 100vw;
		margin-left: calc(50% - 50vw);
		position: relative;
		z-index: 2;
		overflow: hidden;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilGif {
		width: 100%;
		height: auto;
		display: block;
	}

	/* ANIMAÇÃO PARTE 1 */
	.suvinilIntroSection.isVisible .suvinilIntroBrand {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.suvinilIntroSection.isVisible .suvinilUser {
		animation: suvinilFromLeft 0.75s cubic-bezier(0.22, 1, 0.36, 1) 0.45s both;
	}

	.suvinilIntroSection.isVisible .suvinilIntroText {
		animation: suvinilFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.75s both;
	}

	.suvinilIntroSection.isVisible .suvinilGifWrap {
		animation: suvinilSoftAppear 0.9s cubic-bezier(0.22, 1, 0.36, 1) 1.15s both;
	}

	/* =========================================================
	PARTE 2 - INSTAGRAM CARDS + CELULAR
	========================================================= */

	.suvinilInstaSection {
		width: 100%;
		background: #e80000;
		position: relative;
		overflow: hidden;
		padding: 70px 0 0;
	}

	.suvinilInstaContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 980px;
		margin: 0 auto;
		padding: 0;
		box-sizing: border-box;
		position: relative;
		background: #e80000;
	}

	.suvinilInstaHeader {
		width: 100%;
		max-width: 690px;
		margin: 0 auto 54px;
		padding: 0 24px;
		box-sizing: border-box;
		text-align: center;
		color: #ffffff;
		position: relative;
		z-index: 12;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilInstaHeader h2 {
		margin: 0 0 18px;
		color: #80edff;
		font-size: 24px;
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.suvinilInstaHeader p {
		margin: 0;
		color: #ffffff;
		font-size: 17px;
		line-height: 1.45;
		font-weight: 500;
		letter-spacing: -0.035em;
	}

	.suvinilInstaCards {
		position: absolute;
		left: 0;
		top: 230px;
		width: 100%;
		height: 480px;
		z-index: 4;
		pointer-events: none;
	}

	.suvinilInstaCard {
		position: absolute;
		width: 275px;
		border-radius: 0;
		overflow: hidden;
		box-shadow: none;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilInstaCard img {
		width: 100%;
		height: auto;
		display: block;
	}

	/* cards da esquerda */
	.suvinilInstaCard1 {
		left: -8px;
		top: 0;
		z-index: 4;
	}

	.suvinilInstaCard2 {
		left: 275px;
		top: 0;
		z-index: 4;
	}

	/* cards da direita/baixo */
	.suvinilInstaCard3 {
		right: 285px;
		top: 210px;
		z-index: 5;
	}

	.suvinilInstaCard4 {
		right: -8px;
		top: 210px;
		z-index: 5;
	}

	.suvinilPhoneArea {
		position: absolute;
		left: 50%;
		top: 210px;
		width: 410px;
		height: 540px;
		transform: translateX(-50%);
		z-index: 10;
	}

	.suvinilPhone {
		position: absolute;
		left: 50%;
		top: -10%;
		width: 380px;
		height: auto;
		transform: translateX(-50%);
		z-index: 12;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilMetric {
		position: absolute;
		z-index: 8;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilMetric strong {
		display: block;
		color: #80edff;
		font-size: clamp(92px, 8.8vw, 142px);
		line-height: 0.78;
		font-weight: 800;
		letter-spacing: -0.025em;
	}

	.suvinilMetric span {
		display: block;
		margin-top: 8px;
		color: #80edff;
		font-size: 22px;
		line-height: 0.95;
		font-weight:600;
		letter-spacing: -0.055em;
	}

	.suvinilMetric3m {
		right: -306px;
		top: 0;
		text-align: left;
	}

	.suvinilMetric155k {
		left: -345px;
		bottom: -58px;
		text-align: center;
	}

	.suvinilMetric155k strong {
		font-size: clamp(98px, 9vw, 148px);
	}

	.suvinilMetric155k span {
		text-align: center;
	}

	/* ORDEM DA ANIMAÇÃO */

	.suvinilInstaSection.isVisible .suvinilInstaHeader {
		animation: suvinilFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.suvinilInstaSection.isVisible .suvinilInstaCard1 {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both;
	}

	.suvinilInstaSection.isVisible .suvinilInstaCard2 {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.78s both;
	}

	.suvinilInstaSection.isVisible .suvinilInstaCard3 {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.25s both;
	}

	.suvinilInstaSection.isVisible .suvinilInstaCard4 {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.48s both;
	}

	.suvinilInstaSection.isVisible .suvinilPhone {
		animation: suvinilPhoneFromBottom 0.95s cubic-bezier(0.22, 1, 0.36, 1) 1.9s both;
	}

	.suvinilInstaSection.isVisible .suvinilMetric3m {
		animation: suvinilFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 2.35s both;
	}

	.suvinilInstaSection.isVisible .suvinilMetric155k {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 2.35s both;
	}

	/* =========================================================
	   PARTE 3 - POSTS INSTAGRAM
	========================================================= */

	.suvinilPostsSection {
		width: 100%;
		background: #e80000;
		position: relative;
		overflow: hidden;
		padding: 70px 0 135px;
	}

	.suvinilPostsContainer {
		width: 100%;
		max-width: 1440px;
		margin: 0 auto;
		padding: 0 4%;
		box-sizing: border-box;
		position: relative;
	}

	.suvinilPostsText {
		max-width: 760px;
		margin: 0 auto 70px;
		color: #ffffff;
		font-size: 16px;
		line-height: 1.20;
		font-weight: 500;
		text-align: center;
		letter-spacing: -0.055em;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilPostsRow {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 24px;
		position: relative;
	}

	.suvinilPostsRowRight {
		margin-top: 38px;
	}

	.suvinilPost {
		width: calc((100% - 96px) / 5);
		max-width: 230px;
		border-radius: 18px;
		overflow: hidden;
		box-shadow: 0 22px 50px rgba(0, 0, 0, 0.24);
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilPost img {
		width: 100%;
		height: auto;
	}

	.suvinilPost2,
	.suvinilPost4,
	.suvinilPost7,
	.suvinilPost9 {
		margin-top: 70px;
	}

	.suvinilPost1,
	.suvinilPost3,
	.suvinilPost5,
	.suvinilPost6,
	.suvinilPost8,
	.suvinilPost10 {
		margin-top: 0;
	}

	.suvinilPostsSection.isVisible .suvinilPostsText {
		animation: suvinilFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.suvinilPostsSection.isVisible .suvinilPostsRowLeft .suvinilPost {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	.suvinilPostsSection.isVisible .suvinilPost1 {
		animation-delay: 0.55s;
	}

	.suvinilPostsSection.isVisible .suvinilPost2 {
		animation-delay: 0.7s;
	}

	.suvinilPostsSection.isVisible .suvinilPost3 {
		animation-delay: 0.85s;
	}

	.suvinilPostsSection.isVisible .suvinilPost4 {
		animation-delay: 1s;
	}

	.suvinilPostsSection.isVisible .suvinilPost5 {
		animation-delay: 1.15s;
	}

	.suvinilPostsSection.isVisible .suvinilPostsRowRight .suvinilPost {
		animation: suvinilFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	.suvinilPostsSection.isVisible .suvinilPost6 {
		animation-delay: 1.65s;
	}

	.suvinilPostsSection.isVisible .suvinilPost7 {
		animation-delay: 1.8s;
	}

	.suvinilPostsSection.isVisible .suvinilPost8 {
		animation-delay: 1.95s;
	}

	.suvinilPostsSection.isVisible .suvinilPost9 {
		animation-delay: 2.1s;
	}

	.suvinilPostsSection.isVisible .suvinilPost10 {
		animation-delay: 2.25s;
	}

	/* =========================================================
	PARTE 4 - YOUTUBE
	========================================================= */

	.suvinilYoutubeSection {
		width: 100%;
		background: #e80000;
		position: relative;
		overflow: hidden;
		padding: 0 65px 0 95px;
	}

	.suvinilYoutubeContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 850px;
		margin: 0 auto;
		padding: 0 4%;
		box-sizing: border-box;
		position: relative;
		background: #e80000;
	}

	.suvinilYoutubeHeader {
		width: 100%;
		max-width: 680px;
		margin: 0 auto 55px;
		text-align: center;
		color: #ffffff;
		position: relative;
		z-index: 15;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilYoutubeHeader h2 {
		margin: 0 0 20px;
		color: #80edff;
		font-size: 24px;
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.suvinilYoutubeHeader p {
		margin: 0;
		color: #ffffff;
		font-size: 16px;
		line-height: 1.45;
		font-weight: 500;
		letter-spacing: -0.035em;
	}

	/* NOTE CENTRAL */
	.suvinilNote {
		position: absolute;
		left: 55%;
		top: 185px;
		width: min(820px, 62vw);
		height: auto;
		transform: translateX(-50%);
		z-index: 10;
		opacity: 0;
		will-change: transform, opacity;
	}

	/* RISCO ATRÁS DO NOTE */
	.suvinilRisco {
		position: absolute;
		left: 50%;
		top: 32%;
		width: 245px;
		height: auto;
		transform: translateX(-4%);
		z-index: 4;
		opacity: 0;
		will-change: transform, opacity;
	}

	/* FAIXA ATRÁS / EMBAIXO DO NOTE */
	.suvinilFaixa {
		position: absolute;
		left: 19%;
		bottom: 110px;
		width: 215px;
		height: auto;
		z-index: 3;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilYoutubeMetric {
		position: absolute;
		z-index: 12;
		opacity: 0;
		will-change: transform, opacity;
	}

	.suvinilYoutubeMetric strong {
		display: block;
		color: #80edff;
		font-size: clamp(88px, 8.3vw, 138px);
		line-height: 0.8;
		font-weight: 800;
		letter-spacing: -0.075em;
	}

	.suvinilYoutubeMetric span {
		display: block;
		margin-top: 10px;
		color: #80edff;
		font-size: clamp(24px, 2.05vw, 34px);
		line-height: 0.95;
		font-weight: 800;
		letter-spacing: -0.055em;
	}

	.suvinilYoutubeMetric5m {
		left: 7%;
		top: 330px;
		text-align: left;
	}

	.suvinilYoutubeMetric34k {
		right: 8%;
		top: 330px;
		text-align: left;
	}

	/* ORDEM DA ANIMAÇÃO */
	.suvinilYoutubeSection.isVisible .suvinilYoutubeHeader {
		animation: suvinilFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.suvinilYoutubeSection.isVisible .suvinilNote {
		animation: suvinilNoteFromTop 0.95s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both;
	}

	.suvinilYoutubeSection.isVisible .suvinilRisco {
		animation: suvinilRiscoBehindNote 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.15s both;
	}

	.suvinilYoutubeSection.isVisible .suvinilFaixa {
		animation: suvinilFaixaBehindNote 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.15s both;
	}

	.suvinilYoutubeSection.isVisible .suvinilYoutubeMetric5m {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.65s both;
	}

	.suvinilYoutubeSection.isVisible .suvinilYoutubeMetric34k {
		animation: suvinilFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.65s both;
	}

	/* KEYFRAMES ESPECÍFICOS DO YOUTUBE */
	@keyframes suvinilNoteFromTop {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(-120px);
		}

		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}

	@keyframes suvinilRiscoBehindNote {
		from {
			opacity: 0;
			transform: translateX(-35%) translateY(95px) scale(0.95);
		}

		to {
			opacity: 1;
			transform: translateX(-4%) translateY(0) scale(1);
		}
	}

	@keyframes suvinilFaixaBehindNote {
		from {
			opacity: 0;
			transform: translate(220px, -85px) scale(0.95);
		}

		to {
			opacity: 1;
			transform: translate(0, 0) scale(1);
		}
	}

	/* =========================================================
	   KEYFRAMES
	========================================================= */

	@keyframes suvinilFromLeft {
		from {
			opacity: 0;
			transform: translateX(-95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes suvinilFromRight {
		from {
			opacity: 0;
			transform: translateX(95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes suvinilFromTop {
		from {
			opacity: 0;
			transform: translateY(-80px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes suvinilSoftAppear {
		from {
			opacity: 0;
			transform: translateY(32px) scale(0.96);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@keyframes suvinilPhoneFromBottom {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(110px);
		}

		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}

	@keyframes suvinilBehindNoteLeft {
		from {
			opacity: 0;
			transform: translate(250px, 110px);
		}

		to {
			opacity: 1;
			transform: translate(0, 0);
		}
	}

	@keyframes suvinilBehindNoteRight {
		from {
			opacity: 0;
			transform: translate(-250px, -110px);
		}

		to {
			opacity: 1;
			transform: translate(0, 0);
		}
	}

	/* =========================================================
	   RESPONSIVO
	========================================================= */

	@media (max-width: 1366px) {
		/* =========================================================
		   PARTE 1 - INTRO SUVINIL - max-width: 1366px
		========================================================= */

		.suvinilIntroContainer {
			padding-left: 2%;
			padding-right: 2%;
		}

		.suvinilIntroTop {
			padding: 20px 10px;
		}

		/* =========================================================
		   PARTE 2 - INSTAGRAM CARDS + CELULAR - max-width: 1366px
		========================================================= */

		.suvinilInstaContainer {
			padding-left: 2%;
			padding-right: 2%;
			min-height: 870px;
		}

		.suvinilInstaCards {
			left: 2%;
		}

		.suvinilPhoneArea {
			right: 2%;
			width: 50%;
		}

		.suvinilPhone {
			width: min(325px, 82%);
		}

		.suvinilInstaCard3 {
			top: 190px;
			right: 330px;
		}

		.suvinilInstaCard4 {
			right: 50px;
			top: 190px;
		}

		.suvinilMetric3m {
			right: -110px;
		}

		.suvinilMetric155k {
			left: -140px;
		}

		/* =========================================================
		   PARTE 3 - POSTS INSTAGRAM - max-width: 1366px
		========================================================= */

		.suvinilPostsContainer {
			padding-left: 2%;
			padding-right: 2%;
		}

		/* =========================================================
		   PARTE 4 - YOUTUBE - max-width: 1366px
		========================================================= */

		.suvinilYoutubeContainer {
			padding-left: 2%;
			padding-right: 2%;
		}

		.suvinilNote {
			width: min(730px, 72vw);
		}

		.suvinilFaixa {
			left: 16%;
			bottom: 160px;
		}

		.suvinilRisco {
			top: 25%;
		}

		.suvinilYoutubeMetric5m {
			left: 3%;
		}
	}

	@media (max-width: 1100px) {
		/* =========================================================
		   PARTE 1 - INTRO SUVINIL - max-width: 1100px
		========================================================= */

		.suvinilIntroContainer {
			grid-template-columns: 1fr;
			gap: 42px;
		}

		.suvinilIntroText {
			max-width: 720px;
			text-align: left;
		}

		.suvinilGif {
			width: 95%;
		}

		.suvinilGifWrap {
			margin-left: 0;
		}

		/* =========================================================
		   PARTE 2 - INSTAGRAM CARDS + CELULAR - max-width: 1100px
		========================================================= */

		.suvinilInstaContainer {
			min-height: auto;
			display: flex;
			flex-direction: column;
			gap: 60px;
		}

		.suvinilInstaCard1,
		.suvinilInstaCard2,
		.suvinilInstaCard3,
		.suvinilInstaCard4 {
			width: 220px;
		}

		.suvinilInstaCard2 {
			left: 226px;
		}

		.suvinilInstaCard3 {
			right: 280px;
		}

		.suvinilPhoneArea {
			position: relative;
			right: auto;
			top: auto;
			width: 100%;
			min-height: 550px;
		}

		.suvinilPhone {
			width: min(310px, 72%);
		}

		.suvinilMetric3m {
			right: 8%;
			top: 0;
		}

		.suvinilMetric155k {
			left: 8%;
			bottom: 120px;
		}

		/* =========================================================
		   PARTE 3 - POSTS INSTAGRAM - max-width: 1100px
		========================================================= */

		.suvinilPostsRow {
			gap: 18px;
		}

		.suvinilPost {
			width: calc((100% - 72px) / 5);
		}

		/* =========================================================
		   PARTE 4 - YOUTUBE - max-width: 1100px
		========================================================= */

		.suvinilYoutubeContainer {
			min-height: 695px;
		}

		.suvinilNote {
			width: 58vw;
		}

		.suvinilYoutubeMetric5m {
			left: -1%;
			top: 285px;
		}

		.suvinilYoutubeMetric34k {
			right: 6%;
			top: 300px;
		}

		.suvinilFaixa {
			left: 10%;
			bottom: 84px;
		}

		.suvinilRisco {
			top: 32%;
			left: 45%;
		}
	}

	@media (max-width: 768px) {
		/* =========================================================
		   PARTE 1 - INTRO SUVINIL - max-width: 768px
		========================================================= */

		.suvinilIntroSection {
			padding: 45px 0 15px;
		}

		.suvinilIntroContainer {
			padding-left: 18px;
			padding-right: 18px;
		}

		.suvinilLogo {
			width: 210px;
		}

		.suvinilIntroText {
			font-size: 22px;
		}

		/* =========================================================
		   PARTE 2 - INSTAGRAM CARDS + CELULAR - max-width: 768px
		========================================================= */

		.suvinilInstaContainer {
			padding-left: 18px;
			padding-right: 18px;
			gap: 7px;
		}

		.suvinilInstaCard1,
		.suvinilInstaCard2,
		.suvinilInstaCard3,
		.suvinilInstaCard4 {
			width: 160px;
		}

		.suvinilInstaCard2 {
			left: 160px;
		}

		.suvinilInstaCard3 {
			right: 170px;
		}

		.suvinilInstaCard4 {
			right: 0px;
		}

		.suvinilInstaSection {
			padding-bottom: 5px;
			height: 760px;
		}

		.suvinilInstaCards {
			width: 100%;
			position: relative;
			left: auto;
			top: auto;
			grid-template-columns: repeat(2, 1fr);
			gap: 18px;
		}

		.suvinilPhoneArea {
			min-height: 530px;
			top: -520px;
		}

		.suvinilPhone {
			width: 34%;
			top: 0%;
		}

		.suvinilMetric strong {
			font-size: 64px;
		}

		.suvinilMetric span {
			font-size: 13px;
		}

		.suvinilMetric3m {
			right: 70px;
			top: 95px;
		}

		.suvinilMetric155k {
			left: 60px;
			bottom: 150px;
		}

		/* =========================================================
			PARTE 3 - POSTS INSTAGRAM - max-width: 768px
			========================================================= */

			.suvinilPostsSection {
				padding: 55px 0 90px;
			}

			.suvinilPostsContainer {
				padding-left: 18px;
				padding-right: 18px;
			}

			.suvinilPostsText {
				margin-bottom: 45px;
				text-align: left;
			}

			.suvinilPostsRow {
				display: flex;
				justify-content: center;
				align-items: flex-start;
				flex-wrap: nowrap;
				gap: 18px;
				overflow: visible;
				padding-bottom: 18px;
			}

			.suvinilPostsRow::-webkit-scrollbar {
				display: none;
			}

			.suvinilPostsRowLeft,
			.suvinilPostsRowRight {
				margin-top: 28px;
			}

			.suvinilPostsRowLeft .suvinilPost,
			.suvinilPostsRowRight .suvinilPost {
				width: calc((100% - 36px) / 3);
				min-width: 0;
				max-width: none;
			}

			/* mostra apenas 3 cards por linha */
			.suvinilPostsRowLeft .suvinilPost:nth-child(n + 4),
			.suvinilPostsRowRight .suvinilPost:nth-child(n + 4) {
				display: none;
			}

			/* mantém a intercalação */
			.suvinilPostsRowLeft .suvinilPost,
			.suvinilPostsRowRight .suvinilPost {
				margin-top: 0;
			}

			.suvinilPostsRowLeft .suvinilPost:nth-child(2),
			.suvinilPostsRowRight .suvinilPost:nth-child(2) {
				margin-top: 48px;
			}

		/* =========================================================
		   PARTE 4 - YOUTUBE - max-width: 768px
		========================================================= */

		.suvinilYoutubeSection {
			padding: 25px 0 150px;
		}

		.suvinilYoutubeContainer {
			padding-left: 18px;
			padding-right: 18px;
			min-height: 430px;
		}

		.suvinilNote {
			width: 60vw;
			top: 35%;
		}

		.suvinilRisco {
			width: 130px;
			left: 52%;
			top: 40%;
		}

		.suvinilFaixa {
			width: 150px;
			right: 0;
			bottom: -48px;
		}

		.suvinilYoutubeMetric strong {
			font-size: 58px;
		}

		.suvinilYoutubeMetric span {
			font-size: 12px;
		}

		.suvinilYoutubeMetric5m {
			left: 24px;
			top: 265px;
		}

		.suvinilYoutubeMetric34k {
			right: 24px;
			top: 285px;
		}
	}

	@media (max-width: 520px) {
		/* =========================================================
		   PARTE 1 - INTRO SUVINIL MOBILE - max-width: 520px
		========================================================= */

		.suvinilIntroSection {
			padding: 0;
		}

		.suvinilIntroContainer {
			padding-left: 18px;
			padding-right: 18px;
		}

		.suvinilIntroTop {
			min-height: auto;
			padding: 38px 18px 34px;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: 28px;
		}

		.suvinilLogo {
			width: 190px;
		}

		.suvinilUser {
			margin-top: 10px;
			font-size: 15px;
		}

		.suvinilIntroText {
			max-width: 100%;
			margin: 0;
			font-size: 17px;
			line-height: 1.35;
			text-align: left;
		}

		.suvinilGifWrap {
			width: 100vw;
			margin-left: calc(50% - 50vw);
			border-radius: 0;
		}

		.suvinilGif {
			width: 100%;
		}

		/* =========================================================
		   PARTE 2 - INSTAGRAM MOBILE - max-width: 520px
		========================================================= */

		.suvinilInstaSection {
			height: auto;
			min-height: 670px;
			padding: 42px 0 0;
		}

		.suvinilInstaContainer {
			min-height: 670px;
			padding-left: 18px;
			padding-right: 18px;
			display: block;
			gap: 0;
		}

		.suvinilInstaHeader {
			max-width: 100%;
			margin: 0 auto 34px;
			padding: 0;
		}

		.suvinilInstaHeader h2 {
			font-size: 22px;
			margin-bottom: 14px;
		}

		.suvinilInstaHeader p {
			font-size: 15px;
			line-height: 1.45;
		}

		.suvinilInstaCards {
			position: absolute;
			left: 0;
			top: 190px;
			width: 100%;
			height: 430px;
			display: block;
		}

		.suvinilInstaCard {
			width: 138px;
		}

		.suvinilInstaCard1 {
			left: -18px;
			top: 0;
		}

		.suvinilInstaCard2 {
			left: 120px;
			top: 0;
		}

		.suvinilInstaCard3 {
			right: 118px;
			top: 210px;
		}

		.suvinilInstaCard4 {
			right: -18px;
			top: 210px;
		}

		.suvinilPhoneArea {
			position: absolute;
			left: 50%;
			top: 230px;
			width: 230px;
			height: 520px;
			min-height: 520px;
			transform: translateX(-50%);
			z-index: 10;
		}

		.suvinilPhone {
			width: 170px;
			top: -15px;
		}

		.suvinilMetric strong {
			font-size: 54px;
		}

		.suvinilMetric span {
			font-size: 13px;
			line-height: 0.95;
			max-width: 110px;
		}

		.suvinilMetric3m {
			right: -70px;
			top: 48px;
		}

		.suvinilMetric155k {
			left: -75px;
			bottom: 240px;
		}

		.suvinilMetric155k strong {
			font-size: 58px;
		}

		/* =========================================================
			PARTE 3 - POSTS INSTAGRAM MOBILE - max-width: 520px
			========================================================= */

			.suvinilPostsSection {
				padding: 50px 0 35px;
			}

			.suvinilPostsContainer {
				padding-left: 18px;
				padding-right: 18px;
			}

			.suvinilPostsText {
				max-width: 100%;
				margin: 0 0 40px;
				font-size: 16px;
				line-height: 1.08;
				text-align: left;
			}

			.suvinilPostsRow {
				display: flex;
				justify-content: center;
				align-items: flex-start;
				flex-wrap: nowrap;
				gap: 14px;
				overflow: visible;
				padding-bottom: 16px;
				scrollbar-width: none;
			}

			.suvinilPostsRow::-webkit-scrollbar {
				display: none;
			}

			.suvinilPostsRowLeft,
			.suvinilPostsRowRight {
				margin-top: 24px;
			}

			.suvinilPostsRowLeft .suvinilPost,
			.suvinilPostsRowRight .suvinilPost {
				width: calc((100% - 14px) / 2);
				min-width: 0;
				max-width: none;
				border-radius: 12px;
			}

			/* mostra apenas 2 cards por linha */
			.suvinilPostsRowLeft .suvinilPost:nth-child(n + 3),
			.suvinilPostsRowRight .suvinilPost:nth-child(n + 3) {
				display: none;
			}

			/* mantém a intercalação */
			.suvinilPostsRowLeft .suvinilPost,
			.suvinilPostsRowRight .suvinilPost {
				margin-top: 0;
			}

			.suvinilPostsRowLeft .suvinilPost:nth-child(2),
			.suvinilPostsRowRight .suvinilPost:nth-child(2) {
				margin-top: 34px;
			}

		/* =========================================================
		   PARTE 4 - YOUTUBE MOBILE - max-width: 520px
		========================================================= */

		.suvinilYoutubeSection {
			padding: 45px 0 72px;
		}

		.suvinilYoutubeContainer {
			min-height: 380px;
			padding-left: 18px;
			padding-right: 18px;
		}

		.suvinilYoutubeHeader {
			max-width: 100%;
			margin: 0 auto 34px;
		}

		.suvinilYoutubeHeader h2 {
			font-size: 22px;
			margin-bottom: 14px;
		}

		.suvinilYoutubeHeader p {
			font-size: 13px;
			line-height: 1.45;
		}

		.suvinilNote {
			left: 57%;
			top: 175px;
			width: 62vw;
			max-width: 420px;
		}

		.suvinilRisco {
			width: 105px;
			left: 50%;
			top: 175px;
		}

		.suvinilFaixa {
			width: 120px;
			left: 66px;
			right: auto;
			bottom: 10px;
		}

		.suvinilYoutubeMetric strong {
			font-size: 48px;
		}

		.suvinilYoutubeMetric span {
			font-size: 12px;
			line-height: 0.95;
			max-width: 95px;
		}

		.suvinilYoutubeMetric5m {
			left: 18px;
			top: 210px;
		}

		.suvinilYoutubeMetric34k {
			right: 18px;
			top: 210px;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.suvinilIntroBrand,
		.suvinilUser,
		.suvinilIntroText,
		.suvinilGifWrap,
		.suvinilInstaCard,
		.suvinilPhone,
		.suvinilMetric,
		.suvinilPostsText,
		.suvinilPost,
		.suvinilNote,
		.suvinilRisco,
		.suvinilFaixa,
		.suvinilYoutubeMetric {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}

		.suvinilPhone,
		.suvinilNote {
			transform: translateX(-50%) !important;
		}
	}
`;

export const CssDexpro = styled.div`
	width: 100%;
	background: #80edff;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	img {
		max-width: 100%;
		display: block;
	}

	/* =========================================================
	   PARTE 1 - INTRO DEXPRO
	========================================================= */

	.dexproIntroSection {
		width: 100%;
		background: #80edff;
		position: relative;
		overflow: hidden;
	}

	.dexproIntroTop {
		width: 100%;
		max-width: 1440px;
		min-height: 330px;
		margin: 0 auto;
		padding: 75px 6% 55px;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: 36% 64%;
		align-items: center;
		position: relative;
		z-index: 5;
	}

	.dexproIntroBrand {
		position: relative;
		z-index: 3;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproLogo {
		width: 250px;
		height: auto;
	}

	.dexproUser {
		margin: 18px 0 0;
		color: #e00000;
		font-size: 18px;
		line-height: 1;
		font-weight: 500;
		letter-spacing: -0.035em;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproIntroText {
		max-width: 560px;
		margin: 0 0 0 auto;
		color: #132326;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 700;
		letter-spacing: -0.035em;
		text-align: center;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproGifWrap {
		width: 100vw;
		margin-left: calc(50% - 50vw);
		position: relative;
		z-index: 2;
		overflow: hidden;
		opacity: 0;
		will-change: transform, opacity;
		background: #1b4a4c;
	}

	.dexproGif {
		width: 100%;
		height: auto;
		display: block;
	}

	.dexproIntroSection.isVisible .dexproIntroBrand {
		animation: dexproFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.dexproIntroSection.isVisible .dexproUser {
		animation: dexproFromLeft 0.75s cubic-bezier(0.22, 1, 0.36, 1) 0.5s both;
	}

	.dexproIntroSection.isVisible .dexproIntroText {
		animation: dexproFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.85s both;
	}

	.dexproIntroSection.isVisible .dexproGifWrap {
		animation: dexproSoftAppear 0.9s cubic-bezier(0.22, 1, 0.36, 1) 1.25s both;
	}

	/* =========================================================
	   PARTE 2 - INSTAGRAM
	========================================================= */

	.dexproInstaSection {
		width: 100%;
		background: #80edff;
		position: relative;
		overflow: hidden;
		padding: 0 0 60px;
	}

	.dexproInstaContainer {
		width: 100%;
		max-width: 1920px;
		min-height: 1040px;
		margin: 0 auto;
		padding: 0;
		box-sizing: border-box;
		position: relative;
	}

	.dexproInstaHeader {
		width: 100%;
		max-width: 680px;
		margin: 60px auto 70px;
		padding: 0 24px;
		box-sizing: border-box;
		text-align: center;
		position: relative;
		z-index: 12;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproInstaHeader h2,
	.dexproYoutubeHeader h2 {
		margin: 0 0 18px;
		color: #d30000;
		font-size: 24px;
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.dexproInstaHeader p,
	.dexproYoutubeHeader p,
	.dexproPostsText {
		margin: 0;
		color: #132326;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 600;
		letter-spacing: -0.035em;
	}

	.dexproCardsRow {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 8px;
		position: relative;
		z-index: 3;
		box-sizing: border-box;
	}

	.dexproCard {
		width: 305px;
		min-width: 305px;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproCard5 {
		width: 305px;
		min-width: 305px;
	}

	.dexproInstaBottom {
		width: 100%;
		max-width: 1440px;
		height: 420px;
		margin: 55px auto 0;
		position: relative;
	}

	.dexproPhone {
		position: absolute;
		right: 8%;
		top: -300px;
		width: 364px;
		height: auto;
		z-index: 10;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproMetric {
		position: absolute;
		z-index: 7;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproMetric strong {
		display: block;
		color: #e00000;
		font-size: clamp(90px, 9vw, 150px);
		line-height: 0.78;
		font-weight: 800;
		letter-spacing: -0.075em;
	}

	.dexproMetric span {
		display: block;
		margin-top: 10px;
		color: #e00000;
		font-size: clamp(28px, 2.5vw, 44px);
		line-height: 0.95;
		font-weight: 800;
		letter-spacing: -0.055em;
	}

	.dexproMetric33k {
		left: 15%;
		top: 0;
		text-align: center;
	}

	.dexproMetric60k {
		left: 36%;
		top: 0;
		text-align: center;
	}

	.dexproInstaSection.isVisible .dexproInstaHeader {
		animation: dexproFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.dexproInstaSection.isVisible .dexproCard {
		animation: dexproFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	.dexproInstaSection.isVisible .dexproCard1 {
		animation-delay: 0.55s;
	}

	.dexproInstaSection.isVisible .dexproCard2 {
		animation-delay: 0.72s;
	}

	.dexproInstaSection.isVisible .dexproCard3 {
		animation-delay: 0.89s;
	}

	.dexproInstaSection.isVisible .dexproCard4 {
		animation-delay: 1.06s;
	}

	.dexproInstaSection.isVisible .dexproCard5 {
		animation-delay: 1.23s;
	}

	.dexproInstaSection.isVisible .dexproPhone {
		animation: dexproPhoneAppear 0.8s cubic-bezier(0.22, 1, 0.36, 1) 1.45s both;
	}

	.dexproInstaSection.isVisible .dexproMetric33k {
		animation: dexproFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.75s both;
	}

	.dexproInstaSection.isVisible .dexproMetric60k {
		animation: dexproFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.95s both;
	}

	/* =========================================================
	   PARTE 3 - POSTS
	========================================================= */

	.dexproPostsSection {
		width: 100%;
		background: #80edff;
		position: relative;
		overflow: hidden;
		padding: 0 0 95px;
	}

	.dexproPostsContainer {
		width: 100%;
		max-width: 1440px;
		margin: 0 auto;
		padding: 0 4%;
		box-sizing: border-box;
	}

	.dexproPostsText {
		max-width: 720px;
		margin: 0 auto 85px;
		text-align: center;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproPostsRow {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 45px;
	}

	.dexproPost {
		width: calc((100% - 180px) / 5);
		max-width: 261px;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 18px 35px rgba(0, 0, 0, 0.22);
		opacity: 0;
		will-change: transform, opacity;
		cursor: pointer;
	}

	.dexproPost img {
		width: 100%;
		height: auto;
		transition: transform 0.45s ease;
		transform-origin: center center;
		will-change: transform;
	}

	.dexproPost:hover img {
		transform: scale(1.08);
	}

	.dexproPost1,
	.dexproPost5 {
		max-width: 230px;
	}

	.dexproPostsSection.isVisible .dexproPostsText {
		animation: dexproFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.dexproPostsSection.isVisible .dexproPost {
		animation: dexproFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	.dexproPostsSection.isVisible .dexproPost1 {
		animation-delay: 0.55s;
	}

	.dexproPostsSection.isVisible .dexproPost2 {
		animation-delay: 0.72s;
	}

	.dexproPostsSection.isVisible .dexproPost3 {
		animation-delay: 0.89s;
	}

	.dexproPostsSection.isVisible .dexproPost4 {
		animation-delay: 1.06s;
	}

	.dexproPostsSection.isVisible .dexproPost5 {
		animation-delay: 1.23s;
	}

	/* =========================================================
	   PARTE 4 - YOUTUBE
	========================================================= */

	.dexproYoutubeSection {
		width: 100%;
		background: #80edff;
		position: relative;
		overflow: hidden;
		padding: 0 0 10px;
	}

	.dexproYoutubeContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 720px;
		margin: 0 auto;
		padding: 0 4%;
		box-sizing: border-box;
		position: relative;
	}

	.dexproYoutubeHeader {
		width: 100%;
		max-width: 680px;
		margin: 0 auto 0;
		text-align: center;
		position: relative;
		z-index: 15;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproYoutubeStage {
		width: 100%;
		height: 450px;
		position: relative;
	}

	.dexproNote {
		position: absolute;
		left: 50%;
		top: 110px;
		width: min(725px, 58vw);
		height: auto;
		transform: translateX(-50%);
		z-index: 10;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproYoutubeVector {
		position: absolute;
		left: 48%;
		top: 110px;
		width: min(645px, 51vw);
		height: auto;
		transform: translateX(-50%);
		z-index: 4;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproYoutubeMetric {
		position: absolute;
		z-index: 12;
		opacity: 0;
		will-change: transform, opacity;
	}

	.dexproYoutubeMetric strong {
		display: block;
		color: #e00000;
		font-size: clamp(88px, 8.3vw, 140px);
		line-height: 0.8;
		font-weight: 800;
		letter-spacing: -0.075em;
	}

	.dexproYoutubeMetric span {
		display: block;
		margin-top: 10px;
		color: #e00000;
		font-size: clamp(24px, 2.05vw, 34px);
		line-height: 0.95;
		font-weight: 800;
		letter-spacing: -0.055em;
		text-align: center;
	}

	.dexproYoutubeMetric13k {
		left: 5%;
		top: 185px;
		text-align: center;
	}

	.dexproYoutubeMetric700 {
		right: 5%;
		top: 185px;
		text-align: center;
	}

	.dexproYoutubeSection.isVisible .dexproYoutubeHeader {
		animation: dexproFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.dexproYoutubeSection.isVisible .dexproNote {
		animation: dexproNoteFromBottom 0.95s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both;
	}

	.dexproYoutubeSection.isVisible .dexproYoutubeVector {
		animation: dexproVectorBehindNote 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.1s both;
	}

	.dexproYoutubeSection.isVisible .dexproYoutubeMetric13k {
		animation: dexproFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.55s both;
	}

	.dexproYoutubeSection.isVisible .dexproYoutubeMetric700 {
		animation: dexproFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.55s both;
	}

	/* =========================================================
	   KEYFRAMES
	========================================================= */

	@keyframes dexproFromLeft {
		from {
			opacity: 0;
			transform: translateX(-95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes dexproFromRight {
		from {
			opacity: 0;
			transform: translateX(95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes dexproFromTop {
		from {
			opacity: 0;
			transform: translateY(-80px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes dexproSoftAppear {
		from {
			opacity: 0;
			transform: translateY(32px) scale(0.96);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@keyframes dexproPhoneAppear {
		from {
			opacity: 0;
			transform: translateY(55px) scale(0.96);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@keyframes dexproNoteFromBottom {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(120px);
		}

		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}

	@keyframes dexproVectorBehindNote {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(75px) scale(0.9);
		}

		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0) scale(1);
		}
	}

	/* =========================================================
	RESPONSIVO
	========================================================= */

	@media (max-width: 1366px) {
		/* =========================================================
		PARTE 1 - INTRO DEXPRO
		========================================================= */

		.dexproIntroTop {
			padding-left: 5.5%;
			padding-right: 5.5%;
		}

		/* =========================================================
		PARTE 2 - INSTAGRAM
		========================================================= */

		.dexproPhone {
			right: 4%;
			width: 330px;
		}

		.dexproMetric33k {
			left: 7%;
		}

		.dexproMetric60k {
			left: 35%;
		}

		/* =========================================================
		PARTE 3 - POSTS
		========================================================= */

		.dexproPostsContainer {
			padding-left: 5.5%;
			padding-right: 5.5%;
		}

		.dexproPostsRow {
			gap: 30px;
		}

		.dexproPost {
			width: calc((100% - 120px) / 5);
		}

		/* =========================================================
		PARTE 4 - YOUTUBE
		========================================================= */

		.dexproYoutubeContainer {
			padding-left: 5.5%;
			padding-right: 5.5%;
		}
	}

	@media (max-width: 1100px) {
		/* =========================================================
		PARTE 1 - INTRO DEXPRO
		========================================================= */

		.dexproIntroTop {
			grid-template-columns: 1fr;
			gap: 45px;
			min-height: auto;
		}

		.dexproIntroText {
			margin: 0;
			text-align: left;
		}

		/* =========================================================
		PARTE 2 - INSTAGRAM
		========================================================= */

		.dexproInstaContainer {
			min-height: auto;
		}

		.dexproCardsRow {
			width: 100%;
			justify-content: center;
			overflow: visible;
			padding: 0 32px 20px;
			margin-left: 0;
		}

		.dexproCard {
			width: 240px;
			min-width: 240px;
		}
	

		.dexproInstaBottom {
			height: 315px;
		}

		.dexproPhone {
			right: 50px;			
			width: 300px;
		}

		
	

		/* =========================================================
		PARTE 3 - POSTS
		========================================================= */

		.dexproPostsRow {
			/* overflow-x: auto; */
			justify-content: flex-start;
			padding-bottom: 20px;
		}

		.dexproPost,
		.dexproPost1,
		.dexproPost5 {
			width: 210px;
			min-width: 210px;
			max-width: 210px;
		}

		/* =========================================================
		PARTE 4 - YOUTUBE
		========================================================= */

		.dexproYoutubeContainer {
			min-height: 620px;
		}

		.dexproNote {
			width: 58vw;
		}

		.dexproYoutubeMetric13k {
			left: 5%;
		}

		.dexproYoutubeMetric700 {
			right: 5%;
		}
	}

	@media (max-width: 768px) {
		/* =========================================================
		PARTE 1 - INTRO DEXPRO
		========================================================= */

		.dexproIntroTop {
			padding: 50px 32px 42px;
		}

		.dexproLogo {
			width: 245px;
		}

		.dexproIntroText {
			font-size: 18px;
			line-height: 1.45;
		}

		/* =========================================================
		PARTE 2 - INSTAGRAM
		========================================================= */

		.dexproInstaSection {
			padding-bottom: 35px;
		}

		.dexproInstaHeader {
			margin-bottom: 45px;
		}

		.dexproCardsRow {
			justify-content: flex-start;
			overflow-x: auto;
			padding-left: 24px;
			padding-right: 24px;
			scrollbar-width: none;
		}

		.dexproCardsRow::-webkit-scrollbar {
			display: none;
		}

		.dexproCard {
			width: 195px;
			min-width: 195px;
		}

		.dexproCard5 {
			width: 123px;
			min-width: 123px;
		}

		.dexproInstaBottom {
			height: 270px;
			margin-top: 30px;
		}

		.dexproPhone {
			right: 18px;
			top: -250px;
			width: 260px;
		}

		.dexproMetric strong {
			font-size: 70px;
		}

		.dexproMetric span {
			font-size: 24px;
		}
		

		/* =========================================================
		PARTE 3 - POSTS
		========================================================= */

		.dexproPostsSection {
			padding-bottom: 50px;
		}

		.dexproPostsContainer {
			padding-left: 24px;
			padding-right: 24px;
		}

		.dexproPostsText {
			margin-bottom: 45px;
		}

		.dexproPostsRow {
			gap: 10px;
		}

		.dexproPost,
		.dexproPost1,
		.dexproPost5 {
			width: 140px;
			min-width: 140px;
			max-width: 140px;
		}

		/* =========================================================
		PARTE 4 - YOUTUBE
		========================================================= */

		.dexproYoutubeContainer {
			padding-left: 24px;
			padding-right: 24px;
			min-height: 660px;
		}

		.dexproYoutubeHeader {
			margin-bottom: 45px;
		}

		.dexproYoutubeStage {
			height: 600px;
		}

		.dexproNote {
			left: 50%;
			top: 195px;
			width: 88vw;
		}

		.dexproYoutubeVector {
			left: 50%;
			top: 150px;
			width: 78vw;
		}

		.dexproYoutubeMetric strong {
			font-size: 70px;
		}

		.dexproYoutubeMetric span {
			font-size: 23px;
		}

		.dexproYoutubeMetric13k {
			left: 5%;
			top: 20px;
		}

		.dexproYoutubeMetric700 {
			right: 5%;
			top: 20px;
		}
	}

	@media (max-width: 520px) {
		/* =========================================================
		PARTE 1 - INTRO DEXPRO
		========================================================= */

		.dexproIntroTop {
			padding: 42px 24px 36px;
			gap: 34px;
		}

		.dexproLogo {
			width: 210px;
		}

		.dexproUser {
			font-size: 16px;
		}

		.dexproIntroText {
			font-size: 15px;
			line-height: 1.45;
		}

		/* =========================================================
		PARTE 2 - INSTAGRAM
		========================================================= */

		.dexproInstaHeader p {
			font-size: 15px;
			line-height: 1.45;
		}

		.dexproInstaHeader h2 {
			font-size: 22px;
		}

		.dexproCardsRow {
			width: 100%;
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			gap: 8px;
			justify-content: center;
			align-items: flex-start;
			overflow: visible;
			padding: 0 18px 20px;
			box-sizing: border-box;
		}

		.dexproCard {
			width: 100%;
			min-width: 0;
		}

		.dexproCard img {
			width: 100%;
			height: auto;
		}

		.dexproCard5 {
			display: none;
		}

		.dexproInstaBottom {
			height: 235px;
			margin-top: -10px;
		}

		.dexproPhone {
			width: 150px;
			top: -115px;
			right: 10px;
		}

		.dexproMetric strong {
			font-size: 54px;
		}

		.dexproMetric span {
			font-size: 16px;
		}

		.dexproMetric33k {
			left: 18px;
			top: 45px;
		}

		.dexproMetric60k {
			left: 18px;
			top: 150px;
		}
		
		/* =========================================================
			PARTE 3 - POSTS
			========================================================= */

			.dexproPostsContainer {
				padding-left: 18px;
				padding-right: 18px;
			}

			.dexproPostsText {
				font-size: 15px;
				line-height: 1.45;
			}

			.dexproPostsRow {
				width: 100%;
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				gap: 12px;
				justify-content: center;
				align-items: flex-start;
				overflow: visible;
				padding-bottom: 0;
			}

			.dexproPost,
			.dexproPost1,
			.dexproPost5 {
				width: 100%;
				min-width: 0;
				max-width: none;
			}

			.dexproPost img {
				width: 100%;
				height: auto;
			}

			.dexproPost5 {
				display: none;
			}

		/* =========================================================
		PARTE 4 - YOUTUBE
		========================================================= */

		.dexproYoutubeHeader {
			margin-bottom: 0px;
		}


		.dexproYoutubeContainer {
			padding-left: 18px;
			padding-right: 18px;
			min-height: 590px;
		}

		.dexproYoutubeHeader h2 {
			font-size: 22px;
		}

		.dexproYoutubeHeader p {
			font-size: 15px;
			line-height: 1.45;
		}

		.dexproYoutubeStage {
			height: 455px;
		}

		.dexproNote {
			top: 210px;
			width: 96vw;
		}

		.dexproYoutubeVector {
			top: 182px;
			width: 86vw;
		}

		.dexproYoutubeMetric strong {
			font-size: 50px;
		}

		.dexproYoutubeMetric span {
			font-size: 18px;
		}

		.dexproYoutubeMetric13k {
			left: 4%;
			top: 35px;
		}

		.dexproYoutubeMetric700 {
			right: 4%;
			top: 35px;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.dexproIntroBrand,
		.dexproUser,
		.dexproIntroText,
		.dexproGifWrap,
		.dexproInstaHeader,
		.dexproCard,
		.dexproPhone,
		.dexproMetric,
		.dexproPostsText,
		.dexproPost,
		.dexproYoutubeHeader,
		.dexproNote,
		.dexproYoutubeVector,
		.dexproYoutubeMetric {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}

		.dexproPost img {
			transition: none !important;
			transform: none !important;
		}
	}
`;

export const CssEvino = styled.div`
	width: 100%;
	background: #f6ecd7;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	img {
		max-width: 100%;
		display: block;
	}

	/* =========================================================
	   PARTE 1 - INTRO EVINO
	========================================================= */

	.evinoIntroSection {
		width: 100%;
		background: #f6ecd7;
		position: relative;
		overflow: hidden;
	}

	.evinoIntroTop {
		width: 100%;
		max-width: 1440px;
		min-height: 260px;
		margin: 0 auto;
		padding: 58px 6% 50px;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: 36% 64%;
		align-items: center;
		position: relative;
		z-index: 5;
	}

	.evinoIntroBrand {
		position: relative;
		z-index: 3;
		opacity: 0;
		will-change: transform, opacity;
	}

	.evinoLogo {
		width: 170px;
		height: auto;
	}

	.evinoUser {
		margin: 10px 0 0;
		color: #ff0000;
		font-size: 18px;
		line-height: 1;
		font-weight: 500;
		letter-spacing: -0.035em;
		opacity: 0;
		will-change: transform, opacity;
	}

	.evinoIntroText {
		max-width: 560px;
		margin: 0 0 0 auto;
		color: #132326;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 600;
		letter-spacing: -0.035em;
		text-align: center;
		opacity: 0;
		will-change: transform, opacity;
	}

	.evinoIntroSection.isVisible .evinoIntroBrand {
		animation: evinoFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.evinoIntroSection.isVisible .evinoUser {
		animation: evinoFromLeft 0.75s cubic-bezier(0.22, 1, 0.36, 1) 0.5s both;
	}

	.evinoIntroSection.isVisible .evinoIntroText {
		animation: evinoFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.85s both;
	}

	/* =========================================================
	   PARTE 2 - VINHOS
	========================================================= */

	.evinoVinhosSection {
		width: 100%;
		background: #0c2c31;
		position: relative;
		overflow: hidden;
		padding: 0;
	}

	.evinoVinhosContainer {
		width: 100vw;
		margin-left: calc(50% - 50vw);
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.evinoVinhoCard {
		width: 100%;
		position: relative;
		overflow: hidden;
		opacity: 0;
		will-change: transform, opacity;
	}

	.evinoVinhoCard img {
		width: 100%;
		height: auto;
		display: block;
	}

	.evinoVinhosSection.isVisible .evinoVinhoCard {
		animation: evinoFromLeft 0.9s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	.evinoVinhosSection.isVisible .evinoVinhoCard1 {
		animation-delay: 0.1s;
	}

	.evinoVinhosSection.isVisible .evinoVinhoCard2 {
		animation-delay: 0.35s;
	}

	.evinoVinhosSection.isVisible .evinoVinhoCard3 {
		animation-delay: 0.6s;
	}

	/* =========================================================
	   KEYFRAMES EVINO
	========================================================= */

	@keyframes evinoFromLeft {
		from {
			opacity: 0;
			transform: translateX(-95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes evinoFromTop {
		from {
			opacity: 0;
			transform: translateY(-80px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* =========================================================
	   RESPONSIVO
	========================================================= */

	@media (max-width: 1366px) {
		/* =========================================================
		   PARTE 1 - INTRO EVINO
		========================================================= */

		.evinoIntroTop {
			padding-left: 5.5%;
			padding-right: 5.5%;
		}

		/* =========================================================
		   PARTE 2 - VINHOS
		========================================================= */

		.evinoVinhosContainer {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	@media (max-width: 1100px) {
		
		/* =========================================================
		   PARTE 2 - VINHOS
		========================================================= */
		
	}

	@media (max-width: 768px) {

		/* =========================================================
		   PARTE 1 - INTRO EVINO
		========================================================= */

		.evinoIntroTop {
			grid-template-columns: 1fr;
			gap: 42px;
			min-height: auto;
		}

		.evinoIntroText {
			margin: 0;
			text-align: left;
		}


		/* =========================================================
		   PARTE 1 - INTRO EVINO
		========================================================= */

		/* .evinoIntroTop {
			padding: 50px 32px 42px;
		} */

		.evinoLogo {
			width: 160px;
		}

		/* .evinoIntroText {
			font-size: 18px;
			line-height: 1.45;
		} */

		/* =========================================================
		   PARTE 2 - VINHOS
		========================================================= */

		.evinoVinhosContainer {
			grid-template-columns: 1fr;
		}
	}

	@media (max-width: 520px) {
		/* =========================================================
		   PARTE 1 - INTRO EVINO
		========================================================= */

		.evinoIntroTop {
			padding: 42px 24px 36px;
			gap: 34px;
		}

		.evinoLogo {
			width: 145px;
		}

		.evinoUser {
			font-size: 16px;
		}

		.evinoIntroText {
			font-size: 15px;
			line-height: 1.45;
		}

		/* =========================================================
		   PARTE 2 - VINHOS
		========================================================= */

		.evinoVinhosContainer {
			grid-template-columns: 1fr;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.evinoIntroBrand,
		.evinoUser,
		.evinoIntroText,
		.evinoVinhoCard {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}
	}
`;

export const CssEcom = styled.div`
	width: 100%;
	background: #e80000;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	img {
		max-width: 100%;
		display: block;
	}

	/* =========================================================
	   PARTE 1 - INTRO ECOM
	========================================================= */

	.ecomIntroSection {
		width: 100%;
		background: #e80000;
		position: relative;
		overflow: hidden;
	}

	.ecomIntroTop {
		width: 100%;
		max-width: 1440px;
		min-height: 280px;
		margin: 0 auto;
		padding: 72px 6% 58px;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: 34% 66%;
		align-items: center;
		position: relative;
		z-index: 5;
	}

	.ecomIntroBrand {
		position: relative;
		z-index: 3;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomLogo {
		width: 285px;
		height: auto;
	}

	.ecomUser {
		margin: 16px 0 0;
		color: #ffffff;
		font-size: 18px;
		line-height: 1;
		font-weight: 500;
		letter-spacing: -0.035em;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomIntroText {
		max-width: 560px;
		margin: 0 auto;
		color: #ffffff;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 600;
		letter-spacing: -0.035em;
		text-align: center;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomGifWrap {
		width: 100vw;
		margin-left: calc(50% - 50vw);
		position: relative;
		z-index: 2;
		overflow: hidden;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomGif {
		width: 100%;
		height: auto;
	}

	.ecomIntroSection.isVisible .ecomIntroBrand {
		animation: ecomFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.ecomIntroSection.isVisible .ecomUser {
		animation: ecomFromLeft 0.75s cubic-bezier(0.22, 1, 0.36, 1) 0.45s both;
	}

	.ecomIntroSection.isVisible .ecomIntroText {
		animation: ecomFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.8s both;
	}

	.ecomIntroSection.isVisible .ecomGifWrap {
		animation: ecomSoftAppear 0.9s cubic-bezier(0.22, 1, 0.36, 1) 1.2s both;
	}

	/* =========================================================
	   PARTE 2 - INSTAGRAM
	========================================================= */

	.ecomInstaSection {
		width: 100%;
		background: #e80000;
		position: relative;
		overflow: hidden;
		padding: 70px 0 40px;
	}

	.ecomInstaContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 1020px;
		margin: 0 auto;
		position: relative;
		background: #e80000;
	}

	.ecomInstaHeader {
		width: 100%;
		max-width: 700px;
		margin: 0 auto 56px;
		padding: 0 24px;
		box-sizing: border-box;
		text-align: center;
		position: relative;
		z-index: 20;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomInstaHeader h2 {
		margin: 0 0 18px;
		color: #80edff;
		font-size: 26px;
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.ecomInstaHeader p {
		margin: 0;
		color: #ffffff;
		font-size: 16px;
		line-height: 1.45;
		font-weight: 500;
		letter-spacing: -0.035em;
	}

	.ecomInstaStage {
		width: 100%;
		height: 780px;
		position: relative;
	}

	.ecomCardsGrid {
		position: absolute;
		left: 0;
		top: 70px;
		width: 560px;
		display: grid;
		grid-template-columns: repeat(2, 280px);
		grid-auto-rows: auto;
		z-index: 5;
	}

	.ecomCard {
		width: 280px;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomCard img {
		width: 100%;
		height: auto;
	}

	.ecomPhone {
		position: absolute;
		left: 45%;
		top: 115px;
		width: 355px;
		height: auto;
		transform: translateX(-50%);
		z-index: 12;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomMetric {
		position: absolute;
		right: 12%;
		color: #80edff;
		z-index: 10;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomMetric strong {
		display: block;
		color: #80edff;
		font-size: clamp(95px, 9vw, 150px);
		line-height: 0.78;
		font-weight: 800;
		letter-spacing: -0.075em;
	}

	.ecomMetric span {
		display: block;
		margin-top: 10px;
		color: #80edff;
		font-size: clamp(28px, 2.5vw, 42px);
		line-height: 1;
		font-weight: 800;
		letter-spacing: -0.055em;
	}

	.ecomMetric10k {
		top: 170px;
	}

	.ecomMetric8k {
		top: 435px;
	}

	.ecomInstaSection.isVisible .ecomInstaHeader {
		animation: ecomFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.ecomInstaSection.isVisible .ecomCard1 {
		animation: ecomFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both;
	}

	.ecomInstaSection.isVisible .ecomCard2 {
		animation: ecomFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.95s both;
	}

	.ecomInstaSection.isVisible .ecomCard3 {
		animation: ecomFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.35s both;
	}

	.ecomInstaSection.isVisible .ecomCard4 {
		animation: ecomFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.75s both;
	}

	.ecomInstaSection.isVisible .ecomPhone {
		animation: ecomPhoneFromBottom 0.95s cubic-bezier(0.22, 1, 0.36, 1) 2.15s both;
	}

	.ecomInstaSection.isVisible .ecomMetric10k {
		animation: ecomFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 2.65s both;
	}

	.ecomInstaSection.isVisible .ecomMetric8k {
		animation: ecomFromBottom 0.85s cubic-bezier(0.22, 1, 0.36, 1) 3s both;
	}

	/* =========================================================
	   PARTE 4 - YOUTUBE
	========================================================= */

	.ecomYoutubeSection {
		width: 100%;
		background: #e80000;
		position: relative;
		overflow: hidden;
		padding: 70px 0 110px;
	}

	.ecomYoutubeContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 800px;
		margin: 0 auto;
		padding: 0 4%;
		box-sizing: border-box;
		position: relative;
		background: #e80000;
	}

	.ecomYoutubeHeader {
		width: 100%;
		max-width: 700px;
		margin: 0 auto 60px;
		text-align: center;
		position: relative;
		z-index: 20;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomYoutubeHeader h2 {
		margin: 0 0 18px;
		color: #80edff;
		font-size: 26px;
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.ecomYoutubeHeader p {
		margin: 0;
		color: #ffffff;
		font-size: 16px;
		line-height: 1.45;
		font-weight: 500;
		letter-spacing: -0.035em;
	}

	.ecomYoutubeStage {
		width: 100%;
		height: 620px;
		position: relative;
	}

	.ecomNote {
		position: absolute;
		left: 45%;
		top: 60px;
		width: min(800px, 66vw);
		height: auto;
		transform: translateX(-50%);
		z-index: 10;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomRiscoVazado {
		position: absolute;
		left: 30%;
    	top: 95px;
		width: 230px;
		height: auto;
		z-index: 4;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomRisco {
		position: absolute;
		left: 66%;
		bottom: 5px;
		width: 230px;
		height: auto;
		z-index: 4;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomYoutubeMetric {
		position: absolute;
		z-index: 12;
		opacity: 0;
		will-change: transform, opacity;
	}

	.ecomYoutubeMetric strong {
		display: flex;
		align-items: flex-end;
		color: #80edff;
		font-size: clamp(88px, 8.5vw, 145px);
		line-height: 0.78;
		font-weight: 800;
		letter-spacing: -0.075em;
	}

	.ecomYoutubeMetric strong span {
		font-size: clamp(34px, 3.3vw, 58px);
		line-height: 0.9;
		letter-spacing: -0.065em;
		margin-left: 4px;
	}

	.ecomYoutubeMetric > span,
	.ecomYoutubeMetric small {
		display: block;
		margin-top: 12px;
		color: #80edff;
		font-size: clamp(25px, 2.1vw, 36px);
		line-height: 1;
		font-weight: 800;
		letter-spacing: -0.055em;
	}

	.ecomYoutubeMetric150k {
		left: 5%;
		top: 245px;
		text-align: left;
	}

	.ecomYoutubeMetric2mil {
		right: 5%;
		top: 245px;
		text-align: left;
	}

	.ecomYoutubeSection.isVisible .ecomYoutubeHeader {
		animation: ecomFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.ecomYoutubeSection.isVisible .ecomNote {
		animation: ecomNoteFromBottom 0.95s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both;
	}

	.ecomYoutubeSection.isVisible .ecomRiscoVazado {
		animation: ecomRiscoVazadoBehindNote 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.15s both;
	}

	.ecomYoutubeSection.isVisible .ecomRisco {
		animation: ecomRiscoBehindNote 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.15s both;
	}

	.ecomYoutubeSection.isVisible .ecomYoutubeMetric150k {
		animation: ecomFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.65s both;
	}

	.ecomYoutubeSection.isVisible .ecomYoutubeMetric2mil {
		animation: ecomFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.65s both;
	}

	/* =========================================================
	   KEYFRAMES
	========================================================= */

	@keyframes ecomFromLeft {
		from {
			opacity: 0;
			transform: translateX(-95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes ecomFromRight {
		from {
			opacity: 0;
			transform: translateX(95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes ecomFromTop {
		from {
			opacity: 0;
			transform: translateY(-80px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes ecomFromBottom {
		from {
			opacity: 0;
			transform: translateY(80px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes ecomSoftAppear {
		from {
			opacity: 0;
			transform: translateY(32px) scale(0.96);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@keyframes ecomPhoneFromBottom {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(110px);
		}

		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}

	@keyframes ecomNoteFromBottom {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(130px);
		}

		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}

	@keyframes ecomRiscoVazadoBehindNote {
		from {
			opacity: 0;
			transform: translate(160px, 90px) scale(0.94);
		}

		to {
			opacity: 1;
			transform: translate(0, 0) scale(1);
		}
	}

	@keyframes ecomRiscoBehindNote {
		from {
			opacity: 0;
			transform: translateY(120px) scale(0.94);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	/* =========================================================
   RESPONSIVO
========================================================= */

@media (max-width: 1366px) {
	/* =========================================================
	   PARTE 1 - INTRO ECOM
	========================================================= */

	.ecomIntroTop {
		padding-left: 5.5%;
		padding-right: 5.5%;
	}

	/* =========================================================
	   PARTE 2 - INSTAGRAM
	========================================================= */

	.ecomCardsGrid {
		left: 0;
	}

	
	/* =========================================================
	   PARTE 4 - YOUTUBE
	========================================================= */

	.ecomYoutubeMetric150k {
		left: 4%;
	}

	.ecomYoutubeMetric2mil {
		right: 4%;
	}
}

@media (max-width: 1100px) {
	/* =========================================================
	   PARTE 1 - INTRO ECOM
	========================================================= */

	.ecomIntroTop {
		grid-template-columns: 1fr;
		gap: 45px;
		min-height: auto;
	}

	.ecomIntroText {
		margin: 0;
		text-align: left;
	}

	/* =========================================================
	   PARTE 2 - INSTAGRAM
	========================================================= */

	.ecomInstaContainer {
		min-height: 900px;
	}

	.ecomCardsGrid {
		width: 420px;
		grid-template-columns: repeat(2, 210px);
	}

	.ecomCard {
		width: 210px;
	}

	.ecomPhone {
		width: 255px;
	}

	.ecomMetric strong {
		font-size: 88px;
	}

	.ecomMetric span {
		font-size: 27px;
	}

	/* =========================================================
	   PARTE 4 - YOUTUBE
	========================================================= */

	.ecomYoutubeSection{
	    padding: 11px 0 110px;
	}

	.ecomYoutubeContainer {
		min-height: 650px;
	}

	.ecomYoutubeStage {
		height: 520px;
	}

	.ecomNote {
		width: 64vw;
	}

	.ecomRiscoVazado {
		left: 27%;
		width: 180px;
	}

	.ecomRisco {
		width: 180px;
	}
}

@media (max-width: 768px) {
	/* =========================================================
	   PARTE 1 - INTRO ECOM
	========================================================= */

	.ecomIntroTop {
		padding: 50px 32px 42px;
	}

	.ecomLogo {
		width: 220px;
	}

	.ecomIntroText {
		font-size: 18px;
		line-height: 1.45;
	}

	/* =========================================================
	   PARTE 2 - INSTAGRAM
	========================================================= */

	.ecomInstaSection {
		padding-top: 58px;
	}

	.ecomInstaContainer {
		min-height: 500px;
	}

	.ecomInstaStage {
		height: 500px;
	}

	.ecomCardsGrid {
		position: relative;
		left: auto;
		top: 5%;
		width: 55%;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		padding: 0 32px;
		box-sizing: border-box;
	}

	.ecomCard {
		width: 100%;
	}

	.ecomPhone {
		top: 68px;
        left: 56%;
        width: 225px;
	}

	.ecomMetric {
		right: 45px;
	}

	.ecomMetric8k {
		top: 350px;
	}

	.ecomMetric strong {
		font-size: 70px;
	}

	.ecomMetric span {
		font-size: 22px;
	}

	/* =========================================================
	   PARTE 4 - YOUTUBE
	========================================================= */

	.ecomYoutubeHeader {
	    margin: 0 auto 10px;
	}

	.ecomYoutubeSection {
		padding-top: 58px;
	}

	.ecomYoutubeContainer {
		min-height: 590px;
		padding: 0 32px;
	}

	.ecomYoutubeStage {
		height: 430px;
	}

	.ecomNote {
		left: 47%;
        top: 92px;
        width: 52vw;
	}

	.ecomRiscoVazado {
		left: 32%;
        top: 111px;
        width: 135px;
	}

	.ecomRisco {
		left: 60%;
		bottom: 45px;
		width: 135px;
	}

	.ecomYoutubeMetric150k {
		left: 20px;
		top: 235px;
	}

	.ecomYoutubeMetric2mil {
		right: 20px;
		top: 235px;
	}

	.ecomYoutubeMetric strong {
		font-size: 58px;
	}

	.ecomYoutubeMetric strong span {
		font-size: 28px;
	}

	.ecomYoutubeMetric > span,
	.ecomYoutubeMetric small {
		font-size: 20px;
	}
}

@media (max-width: 520px) {
	/* =========================================================
	   PARTE 1 - INTRO ECOM
	========================================================= */

	.ecomIntroTop {
		padding: 42px 24px 36px;
		gap: 34px;
	}

	.ecomLogo {
		width: 180px;
	}

	.ecomUser {
		font-size: 16px;
	}

	.ecomIntroText {
		font-size: 15px;
		line-height: 1.45;
	}

	/* =========================================================
	   PARTE 2 - INSTAGRAM
	========================================================= */

	.ecomInstaSection {
        padding-top: 20px;
    }

	.ecomInstaContainer {
		min-height: 520px;
	}

	.ecomInstaHeader {
		margin-bottom: 42px;
	}

	.ecomInstaHeader h2 {
		font-size: 24px;
	}

	.ecomInstaHeader p {
		font-size: 15px;
	}

	.ecomInstaStage {
		height: 380px;
	}

	.ecomCardsGrid {
		padding: 0 18px;
	}

	.ecomPhone {
		top: 33px;
        left: 33%;
        width: 165px;
	}

	.ecomMetric {
		right: 55px;
	}

	.ecomMetric10k {
		top: 85px;
	}

	.ecomMetric8k {
		top: 200px;
	}

	.ecomMetric strong {
		font-size: 48px;
	}

	.ecomMetric span {
		font-size: 16px;
	}

	/* =========================================================
	   PARTE 4 - YOUTUBE
	========================================================= */
		.ecomYoutubeSection {
			padding: 11px 0 31px;
		}

		.ecomYoutubeHeader h2 {
			font-size: 24px;
		}

		.ecomYoutubeHeader p {
			font-size: 15px;
		}

		.ecomYoutubeContainer {
			min-height: 500px;
			padding: 0 18px;
		}

		.ecomYoutubeStage {
			height: 360px;
		}

		.ecomNote {
			left: 43%;
			top: 105px;
			width: 60vw;
		}

		.ecomRiscoVazado {
			left: 20%;
			top: 120px;
			width: 100px;
		}

		.ecomRisco {
			left: 50%;
			bottom: 70px;
			width: 95px;
		}

		.ecomYoutubeMetric150k {
			left: 12px;
			top: 190px;
		}

		.ecomYoutubeMetric2mil {
			right: 12px;
			top: 190px;
		}

		.ecomYoutubeMetric strong {
			font-size: 38px;
		}

		.ecomYoutubeMetric strong span {
			font-size: 20px;
		}

		.ecomYoutubeMetric > span,
		.ecomYoutubeMetric small {
			font-size: 15px;
			margin-top: 6px;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.ecomIntroBrand,
		.ecomUser,
		.ecomIntroText,
		.ecomGifWrap,
		.ecomInstaHeader,
		.ecomCard,
		.ecomPhone,
		.ecomMetric,
		.ecomYoutubeHeader,
		.ecomNote,
		.ecomRiscoVazado,
		.ecomRisco,
		.ecomYoutubeMetric {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}
	}
`;

export const CssEdp = styled.div`
	width: 100%;
	background: #74dce7;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	img {
		max-width: 100%;
		display: block;
	}

	


	/* =========================================================
	   PARTE 1 - INTRO EDP
	========================================================= */

	.edpIntroSection {
		width: 100%;
		background: #74dce7;
		position: relative;
		overflow: hidden;
		padding: 90px 0 80px;
	}

	.edpIntroContainer {
		width: 100%;
		max-width: 1440px;
		margin: 0 auto;
		padding: 0 4%;
		box-sizing: border-box;
		text-align: center;
		position: relative;
	}

	.edpLogo {
		width: 260px;
		height: auto;
		margin: 0 auto 28px;
		opacity: 0;
		will-change: transform, opacity;
	}

	.edpIntroInfo {
		opacity: 0;
		will-change: transform, opacity;
	}

	.edpIntroInfo h2 {
		margin: 0 0 16px;
		color: #ff0b05;
		font-size: 30px;
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.04em;
	}

	.edpIntroInfo h3 {
		margin: 0;
		color: #ff0b05;
		font-size: 21px;
		line-height: 1.15;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.edpIntroText {
		max-width: 690px;
		margin: 30px auto 0;
		color: #172124;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 600;
		text-align: center;
		letter-spacing: -0.035em;
		opacity: 0;
		will-change: transform, opacity;
	}

	.edpIntroSection.isVisible .edpLogo {
		animation: edpFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.edpIntroSection.isVisible .edpIntroInfo {
		animation: edpFromBottom 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.45s both;
	}

	.edpIntroSection.isVisible .edpIntroText {
		animation: edpFromBottom 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.85s both;
	}

	/* =========================================================
	   PARTE 2 - LINKEDIN / MÉTRICAS / CARDS / CELULAR
	========================================================= */

	.edpLinkedinSection {
		width: 100%;
		background: #74dce7;
		position: relative;
		overflow: hidden;
		padding: 60px 0 90px;
	}

	.edpLinkedinContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 650px;
		margin: 0 auto;
		position: relative;
		padding: 0;
		box-sizing: border-box;
	}

	.edpMetrics {
		width: 100%;
		max-width: 870px;
		margin: 0 auto 58px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		align-items: end;
		gap: 80px;
		position: relative;
		z-index: 12;
	}

	.edpMetric {
		opacity: 0;
		will-change: transform, opacity;
	}

	.edpMetric strong {
		display: block;
		color: #ff0b05;
		font-size: clamp(98px, 10vw, 158px);
		line-height: 0.78;
		font-weight: 800;
		letter-spacing: -0.07em;
	}

	.edpMetric span {
		display: block;
		margin-top: 12px;
		color: #ff0b05;
		font-size: clamp(34px, 3.1vw, 50px);
		line-height: 0.9;
		font-weight: 800;
		letter-spacing: -0.055em;
	}

	.edpMetric33k {
		text-align: left;
	}

	.edpMetric60k {
		text-align: left;
	}

	.edpCardsRow {
		width: 100vw;
		margin-left: calc(50% - 50vw);
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 8px;
		position: relative;
		z-index: 4;
	}

	.edpCard {
		width: 420px;
		min-width: 420px;
		opacity: 0;
		will-change: transform, opacity;
	}

	.edpCard img {
		width: 100%;
		height: auto;
	}

	.edpPhone {
		position: absolute;
		right: 6%;
		top: 35px;
		width: 360px;
		height: auto;
		z-index: 15;
		opacity: 0;
		will-change: transform, opacity;
	}

	.edpLinkedinText {
		max-width: 700px;
		margin: 80px auto 0;
		color: #172124;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 600;
		text-align: center;
		letter-spacing: -0.035em;
		opacity: 0;
		will-change: transform, opacity;
	}

	.edpLinkedinSection.isVisible .edpMetric33k {
		animation: edpFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.edpLinkedinSection.isVisible .edpMetric60k {
		animation: edpFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
	}

	.edpLinkedinSection.isVisible .edpCard1 {
		animation: edpFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both;
	}

	.edpLinkedinSection.isVisible .edpCard2 {
		animation: edpFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.78s both;
	}

	.edpLinkedinSection.isVisible .edpCard3 {
		animation: edpFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.01s both;
	}

	.edpLinkedinSection.isVisible .edpCard4 {
		animation: edpFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.24s both;
	}

	.edpLinkedinSection.isVisible .edpPhone {
		animation: edpPhoneFromTop 0.95s cubic-bezier(0.22, 1, 0.36, 1) 1.65s both;
	}

	.edpLinkedinSection.isVisible .edpLinkedinText {
		animation: edpFromBottom 0.85s cubic-bezier(0.22, 1, 0.36, 1) 2.05s both;
	}

	/* =========================================================
	   KEYFRAMES
	========================================================= */

	@keyframes edpFromTop {
		from {
			opacity: 0;
			transform: translateY(-85px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes edpFromBottom {
		from {
			opacity: 0;
			transform: translateY(85px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes edpFromLeft {
		from {
			opacity: 0;
			transform: translateX(-95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes edpFromRight {
		from {
			opacity: 0;
			transform: translateX(95px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes edpPhoneFromTop {
		from {
			opacity: 0;
			transform: translateY(-120px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* =========================================================
	   RESPONSIVO - 1366px
	========================================================= */

	@media (max-width: 1366px) {
		/* PARTE 1 - INTRO EDP */
		.edpIntroContainer {
			padding: 0 5.5%;
		}

		/* PARTE 2 - LINKEDIN */
		.edpPhone {
			right: 3%;
			width: 330px;
		}

		.edpCard {
			width: 365px;
			min-width: 365px;
		}
	}

	/* =========================================================
	   RESPONSIVO - 1100px
	========================================================= */

	@media (max-width: 1100px) {
		/* PARTE 1 - INTRO EDP */
		.edpIntroSection {
			padding: 75px 0 65px;
		}

		.edpLogo {
			width: 230px;
		}

		/* PARTE 2 - LINKEDIN */
		.edpLinkedinContainer {
			min-height: 590px;
		}

		.edpMetrics {
			max-width: 740px;
			gap: 45px;
		}

		.edpMetric strong {
			font-size: 100px;
		}

		.edpMetric span {
			font-size: 34px;
		}

		.edpCard {
			width: 300px;
			min-width: 300px;
		}

		.edpPhone {
			right: 1%;
			top: 70px;
			width: 280px;
		}
	}

	/* =========================================================
	   RESPONSIVO - 768px
	========================================================= */

	@media (max-width: 768px) {
		/* PARTE 1 - INTRO EDP */
		.edpIntroSection {
			padding: 60px 0 50px;
		}

		.edpIntroContainer {
			padding: 0 32px;
		}

		.edpLogo {
			width: 200px;
			margin-bottom: 24px;
		}

		.edpIntroInfo h2 {
			font-size: 26px;
		}

		.edpIntroInfo h3 {
			font-size: 18px;
		}

		.edpIntroText {
			font-size: 18px;
		}

		/* PARTE 2 - LINKEDIN / MÉTRICAS */
		.edpLinkedinSection {
			padding: 40px 0 70px;
		}

		.edpLinkedinContainer {
			min-height: 1200px;
			padding: 0 0 20px;
		}

		.edpMetrics {
			max-width: 100%;
			padding: 0 32px;
			box-sizing: border-box;
			gap: 20px;
			margin-bottom: 40px;
		}

		.edpMetric strong {
			font-size: 70px;
		}

		.edpMetric span {
			font-size: 24px;
		}

		/* PARTE 2 - CARDS */
		.edpCardsRow {
			width: 100%;
			margin-left: 0;
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			gap: 8px;
			padding: 0 32px;
			box-sizing: border-box;
			overflow: visible;
		}

		.edpCardsRow::-webkit-scrollbar {
			display: none;
		}

		.edpCard {
			width: 100%;
			min-width: 0;
		}

		/* PARTE 2 - CELULAR */
		.edpPhone {
			position: relative;
			right: auto;
			top: auto;
			width: 260px;
			margin: -80px 32px 0 auto;
		}

		/* PARTE 2 - TEXTO FINAL */
		.edpLinkedinText {
			max-width: 53%;
			margin: -276px 32px 0;
			font-size: 16px;
		}
	}

	/* =========================================================
	   RESPONSIVO - 520px
	========================================================= */

	@media (max-width: 520px) {
		/* PARTE 1 - INTRO EDP */
		.edpIntroSection {
			padding: 48px 0 42px;
		}

		.edpIntroContainer {
			padding: 0 24px;
		}

		.edpLogo {
			width: 170px;
		}

		.edpIntroInfo h2 {
			font-size: 24px;
		}

		.edpIntroInfo h3 {
			font-size: 16px;
		}

		.edpIntroText {
			font-size: 15px;
			line-height: 1.45;
		}

		/* PARTE 2 - LINKEDIN / MÉTRICAS */
		.edpLinkedinSection {
			padding: 25px 0 55px;
		}

		.edpMetrics {
			padding: 0 24px;
			gap: 16px;
			margin-bottom: 32px;
		}

		.edpMetric strong {
			font-size: 52px;
		}

		.edpMetric span {
			font-size: 18px;
			margin-top: 8px;
		}

		/* PARTE 2 - CARDS */
		.edpCardsRow {
			grid-template-columns: repeat(2, 1fr);
			gap: 6px;
			padding: 0 18px;
		}

		.edpCard {
			width: 100%;
			min-width: 0;
		}

		/* PARTE 2 - CELULAR */
		.edpPhone {
			width: 205px;
			margin: -55px 18px 0 auto;
		}

		/* PARTE 2 - TEXTO FINAL */
		.edpLinkedinText {
			margin: 35px 24px 0;
			font-size: 15px;
			line-height: 1.45;
			        max-width: 95%;
		}

		.edpLinkedinContainer {
			min-height: 955px;
		}
	}

	/* =========================================================
	   ACESSIBILIDADE - REDUZIR ANIMAÇÕES
	========================================================= */

	@media (prefers-reduced-motion: reduce) {
		.edpLogo,
		.edpIntroInfo,
		.edpIntroText,
		.edpMetric,
		.edpCard,
		.edpPhone,
		.edpLinkedinText {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}
	}
`;